var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center","padding-top":"20%"}},[(_vm.showpay)?_c('el-button',{attrs:{"type":"success"},on:{"click":_vm.gopay}},[_vm._v("立即支付")]):_vm._e(),_c('orderpay',{ref:"orderpay",on:{"paycallback":_vm.paycallback}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }